import { render, staticRenderFns } from "./CarregarOsModal.vue?vue&type=template&id=a5fa8aba&scoped=true"
import script from "./CarregarOsModal.vue?vue&type=script&lang=js"
export * from "./CarregarOsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa8aba",
  null
  
)

export default component.exports